<div class="home">
<!--左側選單-->
<div class="home route_data" [class.rt_list]="state == 4">
    <a class="btn btn_back" role="button" (click)="back()"><img src="/static/images/svg/ic_back.svg" alt="回上一頁">回上一頁</a>
    <a class="btn btn-dark list" data-toggle="collapse" href="#trainCollapse" role="button" aria-expanded="false" aria-controls="trainCollapse"><p>點選收合</p></a>

    <div class="collapse show" id="trainCollapse">
        <div class="card card-body">


            <div class="travel" [class.d-none]="state != 3" >
                <div class="path">
                    <p class="start"><img src="/static/images/svg/ic_RouteStart.svg" alt="起點">{{startLocation.name}}</p>
                    <div class="line"></div>
                    <p class="end"><img src="/static/images/svg/ic_RouteEnd.svg" alt="終點">{{endLocation.name}}</p>
                </div>
                <!-- <form class="form-inline">
                    <label class="my-1 mr-2" for="SelectPref">排序方式</label>
                    <select class="custom-select my-1 mr-sm-2" id="SelectPref">
                    <option selected>請選擇...</option>
                    <option value="1">最少轉乘次數</option>
                    </select>
                </form> -->
            </div>

            <div class="listbox ch" [class.d-none]="state != 3" >
                @for (detailObject of detailArray; track $index) {
                    <div class="box">
                        <div class="d-flex align-items-center time_tt">
                        <input type="radio" name="checkTrain"  [checked]="$index == 0"  (change)="onRadioChange($index)">
                        <label for="check01">{{getChDate(detailObject.start_time)}}<img src="/static/images/svg/ic_arrow01.svg" alt="">{{getChDate(detailObject.end_time)}}</label>
                        </div>
                        <p class="time_total">{{getChTime(detailObject.travel_time)}}  /  ${{detailObject.total_price}}(預估票價)</p>

                        <div class="plan">
                            <a role="button" (click)="showDetail($index)">
                                @for (section of detailObject.sections; track $index ;) {
                                    <span>
                                        <img [src]='getTypeImg(section.type,section.transport)'>
                                        <p [class]='getTypeClass(section.type,section.transport.mode)'>{{section.type == 'pedestrian-station' ? "站間" :section.transport.name}}</p>
                                        <p>{{getMinute(section.travelSummary.duration)}}</p>
                                    </span>

                                    <img src="/static/images/svg/ic_arrow02.svg" alt="" [class.d-none]='$last'>
                                }
                            </a>
                        </div>
                    </div>
                }
            </div>


            @if (detail != null && state == 4) {
                <div class="route_step">
                    <div class="d-flex align-items-center time_tt">
                        {{getChDate(detail.start_time)}}
                        <img src="/static/images/svg/ic_arrow01.svg" alt="">
                        {{getChDate(detail.end_time)}}
                    </div>
                    <p class="time_total">{{ getChTime(detail.travel_time) }}  / {{ getChTime(detail.travel_time) }}  /  ${{ detail.total_price }}(預估票價)</p>

                    <div class="plan">
                        <a role="button">
                            @for (section of detail.sections; track $index ;) {
                                <span>
                                    <img [src]='getTypeImg(section.type,section.transport)'>
                                    <p [class]='getTypeClass(section.type,section.transport.mode)'>{{ section.type == 'pedestrian-station' ? "站間" :section.transport.name }}</p>
                                    <p>{{getMinute(section.travelSummary.duration)}}</p>
                                </span>

                                <img src="/static/images/svg/ic_arrow02.svg" alt="" [class.d-none]='$last'>
                            }
                        </a>
                    </div>
                </div>

                <div class="routeline">
                    <div class="box">
                        <div class="start d-flex justify-content-between">
                            <div class="title">
                                <p class="marktt">{{ startLocation.name }}</p>
                                <p class="add">{{ startLocation.address }}</p>
                            </div>
                            <div class="time">{{getChDate(detail.start_time)}}</div>
                        </div>

                        @for (section of detail.sections; track $index ;) {
                        <div [class]='getBoxClass(section.type,section.transport.mode)'>
                            @if ($index  != 0) {
                            <div class="ttbox d-flex justify-content-between">
                                <p class="title">{{section.departure.place.name}}</p><p class="time">{{getChDate(section.departure.time)}}</p>
                            </div>
                            }
                            <div class="plan">
                                <span>
                                    <img [src]='getTypeImg(section.type,section.transport)'>
                                    <p [class]='getTypeClass(section.type,section.transport.mode)'>{{section.type == 'pedestrian-station' ? "站間" :section.transport.name}}</p>
                                    {{ getdepartureName(section.type,section.departure.place.name) }}
                                </span>
                            </div>
                            @if (section.type == 'transit') {
                                <a data-toggle="collapse" [href]="'#detailCollapse' + $index" role="button" class="collapsed" aria-expanded="false" [attr.aria-controls]="'detailCollapse' + $index">{{getChTime(section.travelSummary.duration)}} ({{section.intermediateStops.length + 1}}站)</a>
                                <div class="collapse" [id]="'detailCollapse' + $index">
                                    @if (section.intermediateStops != null) {
                                        <div class="dotlist">
                                            <ul>
                                            @for (stop of section.intermediateStops; track $index ;) {
                                                <li>
                                                    <p>{{stop.departure.place.name}}</p>
                                                    <p class="time">{{getChDate(stop.departure.time)}}</p>
                                                </li>
                                            }
                                            </ul>
                                        </div>
                                    }@else {

                                    }
                                </div>
                            }@else if(section.data != undefined && section.data.length > 0){
                                <a data-toggle="collapse" [href]="'#detailCollapse' + $index" role="button" class="collapsed" aria-expanded="false" [attr.aria-controls]="'detailCollapse' + $index">{{getChTime(section.travelSummary.duration)}}  /  {{ getChLength(section.travelSummary.length)}}</a>
                                <div class="collapse" [id]="'detailCollapse' + $index">

                                    <div class="dotlist no">
                                        <ul>
                                        @for (step of section.data; track $index ;) {
                                            <li>
                                                <p [innerHTML]="step.instructions"></p>
                                            </li>
                                        }
                                        </ul>
                                    </div>
                                </div>
                            }@else{
                                <div class="w_txt">{{ getChTime(section.travelSummary.duration)}}  /  {{ getChLength(section.travelSummary.length)}}</div>
                            }
                        </div>
                        }

                        <div class="end d-flex justify-content-between">
                            <div class="title">
                                <p class="marktt">{{ endLocation.name }}</p>
                                <p class="add">{{ endLocation.address }}</p>
                            </div>
                            <div class="time">{{getChDate(detail.end_time)}}</div>
                        </div>

                    </div>
                </div>
            }
        </div>
    </div>

</div>
</div>
